<template>
  <h3 style="text-align: center" v-if="!Model.Id">
    Incorrect URL.
    <br />
    <br />
    Example:
    {{
      `${origin}/DataPipelineTransformation/Dataset/0B153Z93-E039-41FB-BCF6-12AA81A0FBSN`
    }}
  </h3>
  <div v-if="Model.Id" class="py-4 container-fluid w-75">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="marketWripper">
            <div style="font-size: 1rem">
              <div class="col-md-12" style="margin-top: 24px" />
              <h2 class="text-center">Edit Dataset</h2>
              <div class="col-md-12" style="margin-top: 24px" />
              <div class="row">
                <label for="firstName" class="col-sm-2 col-form-label"
                  >Dataset Name:</label
                >
                <argon-input
                  class="col-sm"
                  type="text"
                  name="name"
                  size="sm"
                  v-model:value.sync="Model.Name"
                />
              </div>
              <div class="col-md-12" style="margin-top: 24px" />
              <div class="buttons">
                <argon-button
                  variant="gradient"
                  color="light"
                  class="ml-2"
                  size="md"
                  :isLoading="saveButtonClicked"
                  :isLoadingText="'Saving...'"
                  @click="Save"
                  :disabled="!Model.Name"
                  style="width: 200px; margin-left: 20px"
                  >Save</argon-button
                >
                <argon-button
                  variant="gradient"
                  color="light"
                  class="ml-2"
                  size="md"
                  @click="Close"
                  style="width: 200px; margin-left: 20px"
                  >Close</argon-button
                >
              </div>
              <div class="clearfix"></div>
              <div class="col-md-12" style="margin-top: 24px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.marketWripper {
  padding: 10px;
}

.buttons {
  text-align: center;
}
</style>
<script>
import { ArgonInput, ArgonButton } from "@/components/exporter.js";
import { SendGETServerAPI, SendPOSTServerAPI } from "@/customFunctions/Api.js";
import { Toaster } from "@/customFunctions/Utils.js";

export default {
  name: "data-pipeline-market",
  data() {
    return {
      Model: {},
      saveButtonClicked: false,
      component: "",
    };
  },
  async mounted() {
    this.$store.commit("setShowPreloader", true);
    this.component = this.$route.params.pathMatch[0];
    try {
      const regexExp =
        /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
      const splittedRoutePath = this.$route.path.split("/");
      const id = regexExp.test(splittedRoutePath[splittedRoutePath.length - 1])
        ? splittedRoutePath[splittedRoutePath.length - 1]
        : "";

      this.Model = await SendGETServerAPI(
        `dataPipelineTransformation/dataset/${id}`,
        {
          Authorization: "Bearer " + this.$store.state.security.accessToken,
        }
      );
    } catch {
      this.Model = {};
    }
    this.$store.commit("setShowPreloader", false);
  },
  components: { ArgonInput, ArgonButton },
  methods: {
    async Save() {
      this.saveButtonClicked = true;
      const resp = await SendPOSTServerAPI(
        `dataPipelineTransformation/dataset/Save?id=${this.Model.Id}&name=${this.Model.Name}`,
        {
          Authorization: "Bearer " + this.$store.state.security.accessToken,
        }
      ).then((r) => r.json());

      if (resp.isOk) this.Toaster("Data has been saved.", "Success", "success");
      else this.Toaster("Some Server Error...", "Error", "Error");
      this.saveButtonClicked = false;
    },
    Close() {
      window.close();
    },
  },
  setup() {
    return { Toaster };
  },
};
</script>
